import { render, staticRenderFns } from "./DisputeDetails.vue?vue&type=template&id=0aca4b58&scoped=true"
import script from "./DisputeDetails.vue?vue&type=script&lang=js"
export * from "./DisputeDetails.vue?vue&type=script&lang=js"
import style0 from "./DisputeDetails.vue?vue&type=style&index=0&id=0aca4b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca4b58",
  null
  
)

export default component.exports